/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ expiry_date: NonNullable<unknown> }} Subscribed_Card_End_DateInputs */

const en_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subscription End Date: ${i?.expiry_date}`)
};

const ar_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تاريخ انتهاء الاشتراك: ${i?.expiry_date}`)
};

const de_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enddatum des Abonnements: ${i?.expiry_date}`)
};

const es_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fecha límite de suscripción: ${i?.expiry_date}`)
};

const fr_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Date de fin de l'abonnement: ${i?.expiry_date}`)
};

const it_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Data di fine abbonamento: ${i?.expiry_date}`)
};

const ja_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`サブスクリプション終了日：${i?.expiry_date}`)
};

const ko_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`구독 종료일: ${i?.expiry_date}`)
};

const pt_br_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Data de término da assinatura: ${i?.expiry_date}`)
};

const ru_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Дата окончания подписки: ${i?.expiry_date}`)
};

const th_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`วันสิ้นสุดการสมัครสมาชิก: ${i?.expiry_date}`)
};

const tr_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonelik Bitiş Tarihi: ${i?.expiry_date}`)
};

const zh_cn_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus 会员到期日：${i?.expiry_date}`)
};

const zh_tw_subscribed_card_end_date = /** @type {(inputs: Subscribed_Card_End_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`訂閱到期日：${i?.expiry_date}`)
};

/**
* | output |
* | --- |
* | "Subscription End Date: {expiry_date}" |
*
* @param {Subscribed_Card_End_DateInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscribed_card_end_date = /** @type {((inputs: Subscribed_Card_End_DateInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscribed_Card_End_DateInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscribed_card_end_date(inputs)
	if (locale === "ar") return ar_subscribed_card_end_date(inputs)
	if (locale === "de") return de_subscribed_card_end_date(inputs)
	if (locale === "es") return es_subscribed_card_end_date(inputs)
	if (locale === "fr") return fr_subscribed_card_end_date(inputs)
	if (locale === "it") return it_subscribed_card_end_date(inputs)
	if (locale === "ja") return ja_subscribed_card_end_date(inputs)
	if (locale === "ko") return ko_subscribed_card_end_date(inputs)
	if (locale === "pt_br") return pt_br_subscribed_card_end_date(inputs)
	if (locale === "ru") return ru_subscribed_card_end_date(inputs)
	if (locale === "th") return th_subscribed_card_end_date(inputs)
	if (locale === "tr") return tr_subscribed_card_end_date(inputs)
	if (locale === "zh_cn") return zh_cn_subscribed_card_end_date(inputs)
	return zh_tw_subscribed_card_end_date(inputs)
});